import { _Object, CommonPrefix } from "@aws-sdk/client-s3";

/**
 * Filters out an array of S3 objects to not include files with specific file extensions.
 * @param {_Object[]} contents Array of objects to filter against.
 */
const getFilteredListOfObjects = (contents: _Object[] | undefined): _Object[] => {
    // Filter out website files and files with these extensions
    const filterRegex = /robots.txt|asset-manifest.json|favicon.ico|(\w)+(.html|.js|.css|.css.map|.js.LICENSE.txt|\/)$/
    const filteredArray = contents?.filter( (item: _Object) => !item.Key?.match(filterRegex));

    return filteredArray ? filteredArray : [];
};

const getFilteredListOfDirectories = (directories: CommonPrefix[] | undefined ): CommonPrefix[] => {
    // Filter out top level directories containing the website files
    const filterRegex = /^(img|static)\/$/
    return directories === undefined ? [] : directories.filter( (item: CommonPrefix) => !item.Prefix?.match(filterRegex));
}

const getRootDirectories = (): CommonPrefix[] => {
    return [ { Prefix: "pub/" } ]
}

const getPubDirectories = (): CommonPrefix[] => {
    return [ { Prefix: "pub/emdb/" }, { Prefix: "pub/pdb/" }, { Prefix: "pub/pdb_ihm/" } ]
}

export {
    getFilteredListOfObjects,
    getFilteredListOfDirectories,
    getRootDirectories,
    getPubDirectories
}
